import { Routes } from '@angular/router';
import { entityProfileTypeGuard } from '../guards/entity-profile/entity-profile-type.guard';

export const claimProfileRoutes: Routes = [
  {
    path: ':entity-profile-type/:profile-name/claim-profile',
    loadChildren: () => import('@rma/public/profiles/claim-individual'),
    canMatch: [entityProfileTypeGuard],
    data: {
      hideFooter: true,
    },
  },
  {
    path: '',
    loadChildren: () => import('@rma/public/profiles/search-profiles'),
  },
  {
    path: 'contactform/teamsandoffices',
    loadChildren: () => import('@rma/public/profiles/team-office-contact'),
  },
];
